import { gql } from '@apollo/client';
import gqlClient from '../../../../utils/apolloClient';

const updateAreaMutation = gql`
  mutation ($pk_columns: areas_pk_columns_input!, $set: areas_set_input!) {
    update_areas_by_pk(pk_columns: $pk_columns, _set: $set) {
      id
    }
  }
`;

export const updateArea = async (variables: object) => {
  return await gqlClient.mutate<{
    update_areas_by_pk: {
      id: string,
    }
  }>({ mutation: updateAreaMutation!, variables });
}

const updateCategoryAssignmentsMutation = gql`
  mutation ($assignments: [category_area_assignments_insert_input!]!, $remove: [uuid!]!) {
    insert_category_area_assignments(objects: $assignments) {
      returning {
        id
      }
    }
    delete_category_area_assignments(where: { id: { _in: $remove }}) {
      affected_rows
    }
  }
`;

export const updateCategoryAssignments = async (assignments: object[], remove: string[]) => {
  return await gqlClient.mutate<{
    insert_category_area_assignments: {
      returning: [{
        id: string,
      }],
    }
    delete_category_area_assignments: {
      affected_rows: number
    }
  }>({ mutation: updateCategoryAssignmentsMutation!, variables: { assignments, remove } });
}